import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, request) {
  return axios.post(
    api.path("cron.create", { contractId: contractId }),
    request
  );
}

export function update(contractId, cronId, request) {
  return axios.put(
    api.path("cron.update", { contractId: contractId, cronId: cronId }),
    request
  );
}

export function show(contractId, cronId) {
  return axios.get(
    api.path("cron.show", {
      contractId: contractId,
      cronId: cronId
    })
  );
}

export function list(contractId) {
  return axios.get(api.path("cron.index", { contractId: contractId }));
}

export function remove(contractId, cronId) {
  return axios.delete(
    api.path("cron.remove", {
      contractId: contractId,
      cronId: cronId
    })
  );
}

export function turnOn(contractId, cronId) {
  return axios.put(
    api.path("cron.turnOn", { contractId: contractId, cronId: cronId }),
  );
}

export function turnOff(contractId, cronId) {
  return axios.put(
    api.path("cron.turnOff", { contractId: contractId, cronId: cronId }),
  );
}

export function bellOn(contractId, cronId, request) {
  return axios.put(
    api.path("cron.bellOn", { contractId: contractId, cronId: cronId }),
    request
  );
}

export function bellOff(contractId, cronId, request) {
  return axios.put(
    api.path("cron.bellOff", { contractId: contractId, cronId: cronId }),
    request
  );
}
